import { useEffect } from 'react';

export default function usePdfDebugLogs({ targetFigure, notes }) {
  useEffect(() => {
    if (targetFigure) {
      console.log('[PDFSectionViewer] targetFigure prop changed:', targetFigure);
    }
  }, [targetFigure]);

  useEffect(() => {
    if (notes && notes.length > 0) {
      console.log('📝 Notes received in PDFSectionViewer:', {
        count: notes.length,
        notes: notes.map((n) => ({
          id: n.id,
          page_number: n.page_number,
          hasPosition: !!n.position,
          position: n.position,
          position_x: n.position_x,
          position_y: n.position_y,
        })),
      });
    } else if (notes && notes.length === 0) {
      console.log('📝 No notes in PDFSectionViewer');
    }
  }, [notes]);
}
